// extracted by mini-css-extract-plugin
module.exports = {"master":"GenericPaywallModal_master__2d8cE","dialog":"GenericPaywallModal_dialog__XVmx3"};